export const func = {
    decodeHTMLEntities: str => {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = str;
        str = textArea.value;
        textArea.remove();
        return str;
    },
};
